export default __webpack_public_path__ + "static/media/README.f4d6d74b.md";